<template>
	<div>
		<nav-bar-home></nav-bar-home>
		<div>
			<dashboard-stats></dashboard-stats>
		</div>

		<div>
			<div class="container-fluid">
				<section class="cart-main" style="min-height: auto;">
				<main>
					<h3 class="acc-title lg">MY QUOTES</h3>
				</main>

				<div class="table-res">
					<div class="quotes-table-wrap">
					<table class="table-cart table quotes-table">
						<thead>
						<tr>
							<th>Date of Quote</th>
							<th style="padding: 0px 20px;">ID Quote Ref</th>
							<th>Status</th>
						</tr>
						</thead>
						<tbody>
						<tr v-if="!paginatedQuotes.length">
							<td colspan="3" class="quotes-no-results">No quotes found.</td>
						</tr>
						<tr v-for="order in paginatedQuotes" :key="order._id">
							<td>{{ order.sendQuotesDate ? new Date(order.sendQuotesDate).toDateString() : '' }}</td>
							<td><span class="quotes-view-btn" @click="openModal(order)">{{ order.quoteNumber }}</span></td>
							<td>{{ order.quoteStatus }}</td>
						</tr>
						</tbody>
					</table>
					</div>
					<div class="pagination-controls" v-if="userQuotes && userQuotes.length > perPage">
						<button class="btn btn-primary" @click="prevPage" :disabled="currentPage === 1">Previous</button>
						<span class="page-info">Page {{ currentPage }} of {{ totalPages }}</span>
						<button class="btn btn-primary" @click="nextPage" :disabled="currentPage === totalPages">Next</button>
					</div>
				</div>
			</section>
			</div>
			<!-- Cart main content : End -->
			<!--Cart right banner: Begin-->
			<footer-section></footer-section>
			<div class="modal-mask" v-if="orderDetails == true">
				<div class="modal-wrapper " v-if="subquotes != ''">
					<div class="modal-container quotes-modal-container">
						<div class="modal-body">
							<button class="btn btn-danger close-btn quotes-close-btn" @click="closeModal">
								<b>&#10006;</b>
							</button>
							<h3 class="branch-title" style="text-align: center; font-weight: bold; font-size: 30px;">
								<span class="icon icon-one"></span>Quotes Details</h3>
							<br />
							<div class="list-item quotes-info-card" style="font-size: 20px;">
								<span class="col-lg-6"><strong>Quote ID No:</strong> {{ selectedItem.quoteNumber
									}}</span>
								<span class="col-lg-6"><strong>Quote Date:</strong> {{ new
									Date(selectedItem.createdAt).toDateString() }}</span>
								<span class="col-lg-6"><strong>Quote Expiry Date:</strong> {{ quoteExpiryDate }}</span>
								<span class="col-lg-6"><strong>Quote Validity: </strong> ({{ subquotes[0].validity }}
									Days)</span>
								<span class="col-lg-6"><strong>Quote TAT: </strong> {{ subquotes[0].deliveryTurnaround }}</span>
								<span class="col-lg-12"><strong>Product Description:</strong> {{
									subquotes[0].suppliersDesription }}</span>
							</div>
							<div class="qunaity-margin" style="margin: 40px 0 0;">
								<h3 class="text-left acc-title lg" style="margin: 5px;">Quantity Details</h3>
								<br />
								<div class="table-res-modal quotes-table-wrap">
									<table class="table-cart table quotes-table">
										<thead>
										<tr>
											<th>Quantity</th>
											<th>Price</th>
											<th>Status</th>
											<th>Action</th>
										</tr>
										</thead>
										<tbody>
										<tr v-for="order in subquotes" :key="order._id">
											<td>{{ order.quantity.quantity }}</td>
											<td>&euro;{{ order.quantity.sellingProductPrice ?
												$LFT(order.quantity.sellingProductPrice) :
												$LFT(order.quantity.supplierProductCostPrice +
													order.quantity.creditCardCost + order.quantity.markup) }}</td>
											<td>{{ order.quoteStatus }}</td>
											<td>
												<a :href="'/single-product/' + order._id" title="product"
													class="product-name quotes-order-btn">Order</a>
												<p v-if="order.quoteStatus == 'Expired'"><a :href="'/quotes-form/'"
														title="product" class="product-name quotes-order-btn">Get New Quote</a></p>
											</td>
										</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="else-popupwrp" v-else>
					<div class="modal-container quotes-modal-container">
						<div class="modal-body">
							<button class="btn btn-danger close-btn quotes-close-btn" @click="closeModal">
								<b>&#10006;</b>
							</button>
							<br />
							<h3 class="branch-title" style="text-align: center; font-weight: bold; font-size: 30px;">
								<span class="icon icon-one"></span>Quote on the Way</h3>


						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
import NavBarHome from "@/components/NavBarHome.vue"
import DashboardStats from "./DashboardStats.vue"
import FooterSection from "@/components/FooterSection.vue"
import { mapState } from 'vuex'
export default {
	components: { DashboardStats, NavBarHome, FooterSection },
	methods: {
		nextPage() {
			if (this.currentPage < this.totalPages) {
				this.currentPage++;
			}
		},
		prevPage() {
			if (this.currentPage > 1) {
				this.currentPage--;
			}
		},
		async addToCart() {
			this.error = ''

			let fileName = (this.allFiles !== null && this.needArtwork) ? await this.startUpload() : null;
			// if (this.product.product.productPaperSizeFormat.length  && this.q.productPaperSizeFormat.length < 1) this.error = "Please Select a Size"
			// if (this.product.product.productPaperTypeWeight.length  && this.q.productPaperTypeWeight.length < 1) this.error = "Please Select a Type Weight"
			// if (this.product.product.foldingOption.length  && this.q.foldingOption.length < 1) this.error = "Please Select a Folding Option"
			// if (this.product.product.bookletPagination.length  && this.q.bookletPagination.length < 1) this.error = "Please Select a Booklet Pagination"
			// if (this.product.product.bookletType.length  && this.q.bookletType.length < 1) this.error = "Please Select a Booklet Type"
			// return
			if (this.needArtwork) {
				if (!fileName) this.error = "Please Upload Artwork"
			}
			if (this.orderQuantity !== null && this.error.length < 1) {
				let opData = this.selectedItem.opData

				// return
				let cartItem = {
					artwork: fileName,
					quote_id: this.selectedItem._id,
					// product: this.selectedItem.product._id,
					user: this.user._id,
					isPacakgeUsed: false,
					quantity: this.orderQuantity
				}
				// console.log(cartItem);
				// return
				this.$store.dispatch("updateQuoteItem", { q: this.selectedItem._id })
				let dec = await this.$store.dispatch("addCartItem", cartItem)
				if (dec.status) {
					this.cartSuccess()
				}
			} else {
				this.error = (this.error.length) ? this.error : "Please add any sufficient quantity/amount in item first";
			}
		},
		isExpired(d, v) {
			d = new Date(d);
			d.setDate(d.getDate() + v)
			let today = new Date();
			if (today > d) {
				return true
			} else {
				return false
			}
			// return true

		},
		goTo(name) {
			this.$router.push({ name })
		},
		handle(event) {
			this.images = []
			this.allFiles = []
			this.allFiles = event.target.files[0]
			console.log(event, this.allFiles)
			const reader = new FileReader();
			reader.readAsDataURL(this.allFiles);
			reader.onload = () => {
				this.images.push(reader.result)
			};

			// this.allFiles.forEach((element) => {

			// })


		},
		async startUpload() {
			if (this.allFiles !== null) {
				let name = Date.now() + this.allFiles.name
				const formData = new FormData();
				formData.append('encType', 'multipart/form-data');

				formData.append('artworks', this.allFiles, name)
				console.log(formData)
				//   let DD = Date.now()
				let dec = await this.$store.dispatch("uploadFilesArtworks", formData)
				return name
			} else {
				return null
			}

		},
		async cartSuccess() {
			// this.selectedPackage = null;
			// this.orderQuantity = null;
			// this.success = "Product Has Been Added to Cart";
			await this.$store.dispatch("getUser");
			this.$router.push({ path: '/checkout' })
			// this.$store.state.uploadProgress = 0;
			// this.allFiles = null
		},
		async orderNow(order) {
			let dec = await this.$store.dispatch("orderNow", order)
			if (dec.status) {

				alert("order placed")
				this.$store.dispatch("getUserQuotes");
			} else {
				alert("can't place the order")
			}
		},
		openModal(order) {
			this.orderDetails = true;
			this.selectedItem = order;
			this.$store.dispatch("getQuotesQuantity", order._id)
			document.body.style.overflow = "hidden";
			document.body.style.position = "fixed";
			document.body.style.width = "100%";
		},
		closeModal() {
			this.orderDetails = false;
			this.selectedItem = null;
			document.body.style.overflow = "";
			document.body.style.position = "";
			document.body.style.width = "";
		},
	},
	computed: {
		...mapState(['userQuotes', 'user', 'subquotes']),
		totalPages() {
			return Math.max(1, Math.ceil((this.userQuotes || []).length / this.perPage));
		},
		paginatedQuotes() {
			if (!this.userQuotes || this.userQuotes.length <= 0) return [];
			const start = (this.currentPage - 1) * this.perPage;
			const end = start + this.perPage;
			return this.userQuotes.slice(start, end);
		},
		quoteExpiryDate() {
			if (this.selectedItem && this.selectedItem.createdAt) {
				let createdAt = new Date(this.selectedItem.createdAt);
				createdAt.setDate(createdAt.getDate() + this.selectedItem.validity);
				return createdAt.toDateString(); // Format as YYYY-MM-DD
			}
			return '';
		}
	},
	watch: {
		userQuotes() {
			if (this.currentPage > this.totalPages) {
				this.currentPage = 1;
			}
		}
	},
	beforeDestroy() {
		document.body.style.overflow = "";
		document.body.style.position = "";
		document.body.style.width = "";
	},
	mounted() {
		this.$store.dispatch("getUserQuotes")
	},
	data() {
		return {
			selectedItem: null,
			files: [],
			orderQuantity: null,
			allFiles: null,
			error: "",
			images: [],
			needArtwork: true,
			tab: 0,
			orderDetails: false,
			currentPage: 1,
			perPage: 10,
		}
	}
}
</script>

<style>
.tabs {
	margin: 13px 0px;
	border-bottom: 1px solid lightgray;
	padding: 5px 0px;
}

.tab {
	color: red;
	padding: 5px 25px;
	cursor: pointer;
}

.selected {
	border-bottom: 4px solid red;
}

.link {
	color: blue;
	font-weight: 800;
}

.item-details .first {
	display: inline-block;
	width: 160px;
}

.item-details {
	padding: 11px 4px;
	margin: 0px;
}

.sec {
	background: aliceblue;
}

.head {
	background: #fd5b4e;
}

.v-input {
	position: absolute;
	z-index: 9999;
	height: 100%;
	border: 2px solid red;
	width: 100%;
	opacity: 0;
}

.modal-mask {
	position: fixed;
	z-index: 999899989998;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: table;
	transition: opacity 0.3s ease;
}

.modal-wrapper {
	display: table-cell;
	vertical-align: middle;
}

.modal-container {
	max-width: 1200px;
	margin-left: auto;
	margin-right: auto;
	/* margin: 0px auto; */
	padding: 1px 0px;
	background-color: #fff;
	border-radius: 2px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
	transition: all 0.3s ease;
	font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
	margin-top: 0;
	color: #42b983;
}

.modal-body {
	margin: 0px 0;
}

.modal-default-button {
	float: right;
}

/*
	* The following styles are auto-applied to elements with
	* transition="modal" when their visibility is toggled
	* by Vue.js.
	*
	* You can easily play with the modal transition by editing
	* these styles.
	*/

.modal-enter {
	opacity: 0;
}

.modal-leave-active {
	opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
}

.close-btn {
	padding: 3px 7px;
	font-size: 12px;
	line-height: 1.5;
	border-radius: 3px;
}
.else-popupwrp {
    height: 100vh;
    display: flex;
	align-items: center;
}

.else-popupwrp .modal-container {
    height: 350px;
	width: 100%;
}

@media (max-width: 768px) {
	.row {
		padding: 0 15px;
	}

	.calculate-spend {
		margin-top: 10px;
	}
	.table-res{
		overflow: auto;
		text-wrap: nowrap;
	}
	.table-res-modal {
		overflow: auto;
		text-wrap: nowrap;
		max-width: 300px;
	}

	.table-res th,
	.table-res td {
		padding: 10px 20px !important;
	}

	a.product-name {
		font-size: 15px;
		padding: 10px;
	}

	.modal-mask {
		padding: 20px;
	}

	.branch-title {
		text-align: start !important;
		font-size: 20px !important;
	}

	.list-item {
		display: flex;
		flex-direction: column;
		gap: 10px;
		font-size: 16px !important;
	}

	.list-item span {
		padding: 0px;
	}

	.qunaity-margin {
		margin: 20px 0 !important;
	}
}

/* .c-table > tr > th{ padding:10px; font-weight:600; font-size:14px;} */
/* .c-table > tr > td{ padding:10px; font-size:14px;} */

section.cart-main span{
	color:#000;
}
section.cart-main .link{
  color: #000;
}
@media(max-width:768px){
	    .user-dashboard-menuWrap .c-icon {
        margin-left: 28%;
        margin-top: 11%;
    }
	
}

@media(max-width:550px){
	    .user-dashboard-menuWrap .c-icon {
        margin-left: 33%;
        margin-top: 16%;
    }
}
.pagination-controls {
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 20px 0;
	gap: 14px;
}
.pagination-controls button {
	border-radius: 30px;
	padding: 8px 22px;
	text-transform: uppercase;
	font-weight: 600;
	font-size: 13px;
	letter-spacing: .03em;
}
.pagination-controls button:disabled {
	opacity: .45;
	cursor: not-allowed;
}
.page-info {
	margin: 0;
	font-size: 13px;
	font-weight: 600;
	color: #555;
	background: #f5f5f5;
	padding: 6px 16px;
	border-radius: 20px;
}

.quotes-table-wrap {
	margin: 20px 0;
	overflow: auto;
	background: #fff;
	border-radius: 12px;
	box-shadow: 0 2px 14px rgba(0, 0, 0, 0.06);
	border: 1px solid #eee;
}

.quotes-table {
	margin: 0 !important;
}

.quotes-table th {
	background: #fff5f4 !important;
	color: #3a3a3a !important;
	text-transform: uppercase;
	font-size: 12px;
	letter-spacing: .04em;
	font-weight: 700 !important;
	padding: 14px 20px !important;
	white-space: nowrap;
	border: none !important;
	border-bottom: 2px solid #fd5b4e !important;
	text-align: left !important;
}

.quotes-table td {
	padding: 14px 20px !important;
	font-size: 14px;
	vertical-align: middle !important;
	border-bottom: 1px solid #f0f0f0;
	text-align: left !important;
}

.quotes-table tbody tr:last-child td {
	border-bottom: none;
}

.quotes-table tbody tr:nth-child(even) {
	background: #fafbfc;
}

.quotes-table tbody tr:hover {
	background: #fff4f2;
}

.quotes-no-results {
	text-align: center !important;
	padding: 40px 20px !important;
	color: #999;
	font-size: 14px;
}

.quotes-view-btn {
	display: inline-block;
	padding: 5px 16px;
	border-radius: 20px;
	background: #fff0ee;
	color: #fd5b4e;
	font-weight: 700;
	font-size: 12px;
	text-transform: uppercase;
	letter-spacing: .03em;
	cursor: pointer;
	transition: background .2s ease, color .2s ease;
}

.quotes-view-btn:hover {
	background: #fd5b4e;
	color: #fff;
}

.quotes-modal-container {
	border-radius: 14px;
	overflow: hidden;
	box-shadow: 0 16px 40px rgba(0, 0, 0, 0.25);
}

.quotes-close-btn {
	float: right;
	margin: 20px 20px 0 0 !important;
	width: 32px;
	height: 32px;
	padding: 0 !important;
	border-radius: 50% !important;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	font-size: 13px;
	border: none;
}

.quotes-info-card {
	padding: 0 22px;
	margin: 16px 0 24px;
}

.quotes-order-btn {
	display: inline-block !important;
	float: none !important;
	width: auto !important;
	padding: 6px 18px;
	border-radius: 20px;
	background: #fd5b4e;
	color: #fff !important;
	font-weight: 700 !important;
	font-size: 12px !important;
	text-transform: uppercase;
	letter-spacing: .03em;
	text-decoration: none !important;
	transition: opacity .2s ease;
}

.quotes-order-btn:hover {
	opacity: .88;
}</style>